import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "./components/theme/ThemeProvider";
import { registerAppServiceWorker } from "./pwa/registerSW";
import { AppErrorBoundary } from "./components/errors/AppErrorBoundary";
import { clearStaleAppCaches, reserveChunkReload } from "./lib/chunkRecovery";

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const failure = (event as Event & { payload?: unknown }).payload ?? "Importing a module script failed";
  if (reserveChunkReload(failure)) {
    void clearStaleAppCaches().finally(() => window.location.reload());
  }
});

registerAppServiceWorker();

const rootElement = document.getElementById("root")!;
const staticFallback = rootElement.querySelector("[data-geominer-static-fallback]");
let staticFallbackObserver: MutationObserver | null = null;
if (staticFallback) {
  staticFallbackObserver = new MutationObserver(() => {
      if (!rootElement.querySelector("[data-geominer-static-fallback]")) {
        document.documentElement.classList.remove("geominer-js");
        staticFallbackObserver?.disconnect();
      }
    });
  staticFallbackObserver.observe(rootElement, { childList: true });
}

createRoot(rootElement).render(
  <AppErrorBoundary>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </AppErrorBoundary>
);
